/**
 * Single source of truth for resume upload constraints. Imported by both the
 * server action that enforces them and the client UI that previews them.
 */

export const MAX_RESUME_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const ACCEPTED_RESUME_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
] as const;

export const ACCEPTED_RESUME_FILE_EXTENSIONS = '.pdf,.doc,.docx,.txt' as const;

export const RESUME_FORMATS_HUMAN_LABEL = 'PDF, DOCX, or TXT';
export const RESUME_MAX_SIZE_HUMAN_LABEL = 'max 10MB';

export type ResumeFileValidation =
  | { ok: true }
  | { ok: false; reason: 'too-large' | 'wrong-type'; message: string };

export function validateResumeFile(file: File): ResumeFileValidation {
  if (file.size > MAX_RESUME_FILE_SIZE_BYTES) {
    return {
      ok: false,
      reason: 'too-large',
      message: `File size must be less than ${Math.round(MAX_RESUME_FILE_SIZE_BYTES / (1024 * 1024))}MB`,
    };
  }
  if (!ACCEPTED_RESUME_MIME_TYPES.includes(file.type as (typeof ACCEPTED_RESUME_MIME_TYPES)[number])) {
    return {
      ok: false,
      reason: 'wrong-type',
      message: `Only ${RESUME_FORMATS_HUMAN_LABEL} files are allowed`,
    };
  }
  return { ok: true };
}
